"use client";

import { useRouter } from "next/navigation";
import { useRef, useState } from "react";
import { GuguBird } from "./gugu-bird";

export function FloatingGugu() {
  const router = useRouter();
  const [pos, setPos] = useState<{ x: number | string; y: number | string }>({ x: "calc(100vw - 78px)", y: "116px" });
  const drag = useRef<{ dx: number; dy: number; moved: boolean } | null>(null);

  function move(clientX: number, clientY: number) {
    const d = drag.current;
    if (!d) return;
    d.moved = true;
    setPos({
      x: Math.max(10, Math.min(window.innerWidth - 66, clientX - d.dx)),
      y: Math.max(72, Math.min(window.innerHeight - 118, clientY - d.dy)),
    });
  }

  return (
    <button
      type="button"
      data-el="floating-gugu"
      aria-label="和咕咕说话"
      className="fixed z-40 rounded-full border border-white/30 bg-white/15 p-1.5 shadow-[0_0_28px_rgba(244,211,142,0.28)] backdrop-blur-sm transition active:scale-95"
      style={{ left: pos.x, top: pos.y, touchAction: "none" }}
      onPointerDown={(e) => {
        e.currentTarget.setPointerCapture(e.pointerId);
        const rect = e.currentTarget.getBoundingClientRect();
        drag.current = { dx: e.clientX - rect.left, dy: e.clientY - rect.top, moved: false };
      }}
      onPointerMove={(e) => move(e.clientX, e.clientY)}
      onPointerUp={() => {
        const moved = drag.current?.moved;
        drag.current = null;
        if (!moved) router.push("/gugu");
      }}
    >
      <GuguBird size={54} />
    </button>
  );
}
